import { Component } from '@angular/core';

@Component({
  selector: 'app-workshop-jobcard-skeleton-loader',
  templateUrl: './workshop-jobcard-skeleton-loader.component.html',
  styleUrls: ['./workshop-jobcard-skeleton-loader.component.scss']
})
export class WorkshopJobcardSkeletonLoaderComponent {

}
